import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TitleUpdater = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const titles: Record<string, string> = {
      "/": "MyHPSupport",
      "/create-case": "Create Case",
      "/edit-case": "Edit Case",
      '/case-match' : 'Case Match',
      '/contract-warranties' : 'Contract Warranty',
      '/profile' : 'Profile',
      '/signup' : 'New User Registration',
      '/my-cases' : 'My Cases'
    };

    document.title = titles[pathname] || "MyHPSupport";
  }, [pathname]);

  return null;
};

export default TitleUpdater;
